import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProcessingProvider } from "@/context/ProcessingContext";
import SolangeWidget from "@/components/SolangeWidget";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Checkout from "@/pages/Checkout";
import CompleteSignup from "@/pages/CompleteSignup";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import NewProduct from "@/pages/NewProduct";
import ProductReview from "@/pages/ProductReview";
import Admin from "@/pages/Admin";
import InactiveSubscription from "@/pages/InactiveSubscription";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ProcessingProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/criar-conta" element={<CompleteSignup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/esqueci-senha" element={<ForgotPassword />} />
              <Route path="/resetar-senha" element={<ResetPassword />} />
              <Route path="/assinatura-inativa" element={<InactiveSubscription />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/painel" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/novo" element={<ProtectedRoute><NewProduct /></ProtectedRoute>} />
              <Route path="/produto/:id" element={<ProtectedRoute><ProductReview /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
            </Routes>
            <SolangeWidget />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </ProcessingProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
